
export default {
  name: 'Blank'
}
